import { z } from "zod";

export const basePaymentSchema = z.object({
  cardHolderName: z.string().min(1, "Cardholder name is required"),
});

export const paymentSchema = basePaymentSchema.extend({
  planId: z.string().min(1, "Plan ID is required"),
  auto_renew: z.boolean().default(true),
  acceptTerms: z.boolean().refine((val) => val === true, {
    message: "Required",
  }),
  workspace_id: z.string().min(1, "Workspace ID is required"),
});